'use client';

import { useContext } from 'react';

import type { AviosAuthContextValue } from '../core/types';

import { AviosAuthContext } from './AviosAuthContext';

/**
 * Read auth state from the nearest AviosAuthProvider.
 *
 * Works in any client component inside the provider tree.
 * For server components, use getAviosAuthServerSession() instead.
 */
export function useAviosAuth(): AviosAuthContextValue {
  const ctx = useContext(AviosAuthContext);
  if (!ctx) {
    throw new Error(
      'useAviosAuth() must be used within an <AviosAuthProvider>. ' +
        'Wrap your app or layout in <AviosAuthProvider> from @channel/shared-header-footer.'
    );
  }
  return ctx;
}

export function useOptionalAviosAuth(): AviosAuthContextValue | undefined {
  const ctx = useContext(AviosAuthContext);
  if (!ctx) return undefined;
  return ctx;
}
